// DO NOT EDIT -- generated from fs/services/llm-tool/session_summary.proto

import { CacheOptions, LlmModel } from './llm.proto';
import * as dx_objects from '../dx-objects';
import * as protobuf from '../../../google/protobuf';
import * as search from '../../api/search';

export namespace SessionSummaryPublic {

  export const SessionSummaryEndpoint = "/grpc/llm_tool.SessionSummaryPublic/SessionSummary";
  export function SessionSummary(sender: (req: SessionSummaryRequest, endpoint: string) => Promise<SessionSummaryResponse>, req: SessionSummaryRequest): { promise: () => Promise<SessionSummaryResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SessionSummaryEndpoint),
      endpoint: SessionSummaryEndpoint
    };
  }

  // unsupported streaming endpoint
  export const SessionSummaryStreamingEndpoint = "/grpc/llm_tool.SessionSummaryPublic/SessionSummaryStreaming";

  export const BulkSessionSummaryEndpoint = "/grpc/llm_tool.SessionSummaryPublic/BulkSessionSummary";
  export function BulkSessionSummary(sender: (req: BulkSessionSummaryRequest, endpoint: string) => Promise<BulkSessionSummaryResponse>, req: BulkSessionSummaryRequest): { promise: () => Promise<BulkSessionSummaryResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BulkSessionSummaryEndpoint),
      endpoint: BulkSessionSummaryEndpoint
    };
  }

  export const WorkforceSessionSummaryEndpoint = "/grpc/llm_tool.SessionSummaryPublic/WorkforceSessionSummary";
  export function WorkforceSessionSummary(sender: (req: WorkforceSummaryRequest, endpoint: string) => Promise<SessionSummaryResponse>, req: WorkforceSummaryRequest): { promise: () => Promise<SessionSummaryResponse>, endpoint: string } {
    return {
      promise: () => sender(req, WorkforceSessionSummaryEndpoint),
      endpoint: WorkforceSessionSummaryEndpoint
    };
  }

  export const WorkforceFeedbackSummaryEndpoint = "/grpc/llm_tool.SessionSummaryPublic/WorkforceFeedbackSummary";
  export function WorkforceFeedbackSummary(sender: (req: WorkforceSummaryRequest, endpoint: string) => Promise<SessionSummaryResponse>, req: WorkforceSummaryRequest): { promise: () => Promise<SessionSummaryResponse>, endpoint: string } {
    return {
      promise: () => sender(req, WorkforceFeedbackSummaryEndpoint),
      endpoint: WorkforceFeedbackSummaryEndpoint
    };
  }
}

export interface SessionSummaryRequest {
  orgId: string;
  userId: string;
  sessionId: string;
  /** timestamp where the note was created */
  timestamp: protobuf.timestamp | null;
  /** Must select one of the fine tuned models */
  llmModel: SessionSummaryRequest.Model;
  /** Cache options for the request */
  cacheOptions: CacheOptions | null;
}

export namespace SessionSummaryRequest {
  export enum Model {
    INVALID = 0,
    V2_FLASH = 7,
    V2_FLASH_FEW_SHOT = 8,
    V0_TAGS = 9
  }
}

export interface SessionSummaryResponse {
  summary: string;
}

export interface SessionToSummarize {
  userId: string;
  sessionId: string;
  timestamp: protobuf.timestamp | null;
  /** optional, used to identify the user in the summary. */
  userName: string;
}

export interface BatchSessionIds {
  sessionIds: SessionToSummarize[];
}

export enum CannedPrompt {
  DEFAULT = 0,
  TAGS = 1,
  USER_LINKS = 2
}

export interface BulkSummaryPrompt {
  cannedPrompt?: CannedPrompt;
  customPrompt?: string;
}

export namespace BulkSummaryPrompt {
  export enum prompt {
    cannedPrompt = 1,
    customPrompt = 2
  }

  export function prompt_oneof(m: BulkSummaryPrompt): { opt: prompt.cannedPrompt, val: CannedPrompt } | { opt: prompt.customPrompt, val: string } | null {
    if (m.cannedPrompt != null) { return { opt: prompt.cannedPrompt, val: m.cannedPrompt } }
    if (m.customPrompt != null) { return { opt: prompt.customPrompt, val: m.customPrompt } }
    return null;
  }
}

export interface ObjectContext {
  objectType: dx_objects.ObjectType;
  objectName: string;
  objectDescription: string;
}

export interface BulkSessionSummaryRequest {
  orgId: string;
  llmModel: LlmModel;
  /**
   * Even if sending session IDs, we still need to send event search so that we
   * have context on where the IDs are coming from. Otherwise, the LLM will
   * mention patterns that are obvious from the search.
   */
  eventSearch: search.EventSearch | null;
  batchSize?: number;
  sessionIds?: BatchSessionIds | null;
  prompts: BulkSummaryPrompt[];
  baseSummaryModel: SessionSummaryRequest.Model;
  timezone: string;
  objectContext: ObjectContext | null;
  /** If true, use raw session data instead of summaries */
  useRawSessionData: boolean;
}

export namespace BulkSessionSummaryRequest {
  export enum sessions_to_summarize {
    batchSize = 4,
    sessionIds = 5
  }

  export function sessions_to_summarize_oneof(m: BulkSessionSummaryRequest): { opt: sessions_to_summarize.batchSize, val: number } | { opt: sessions_to_summarize.sessionIds, val: BatchSessionIds } | null {
    if (m.batchSize != null) { return { opt: sessions_to_summarize.batchSize, val: m.batchSize } }
    if (m.sessionIds != null) { return { opt: sessions_to_summarize.sessionIds, val: m.sessionIds } }
    return null;
  }
}

export interface BaseSummary {
  summary: string;
  session: SessionToSummarize | null;
}

export interface BulkSummary {
  summary: string;
  prompt: BulkSummaryPrompt | null;
}

export interface BulkSessionSummaryResponse {
  summaries: BulkSummary[];
  baseSummaries: BaseSummary[];
}

export interface WorkforceSummaryRequest {
  orgId: string;
  userId: string;
  sessionId: string;
  appName: string;
  /** optional, page the user was on during feedback submission */
  pageUrl: string;
  /** optional, feedback submission from feedback widget */
  feedback: string;
  startTimestamp: protobuf.timestamp | null;
  endTimestamp: protobuf.timestamp | null;
}
